<template>
  <div class="history-item">
    <h3 class="title" v-html="title" />
    <img class="charactors" :src="charactors">
    <div class="result-button">
      <btn-blue @click="goToPage">
        <img class="text" :src="textGoResult" :alt="$t('btn001')">
      </btn-blue>
    </div>
  </div>
</template>
<script>
import BtnBlue from '@components/global/button-blue.vue'
import localeAbout from '@locales/about'
export default {
  name: 'historyItem',
  $messages: localeAbout,
  components: {
    BtnBlue,
  },
  props: {
    count: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    }
  },
  computed: {
    charactors() {
      return require(`@images/about/heroes/charactors${this.count}.png`)
    },
    textGoResult() {
      return require(`@images/about/${this.$route.params.lang}/go-result.png`)
    }
  },
  methods: {
    goToPage() {
      window.open(this.url, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.history-item {
  padding: 20px 0 40px 0;
  background-image: url(#{$img-path}about/bg_history-item.png);
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: auto 100%;
  > .title {
    color: $color-black;
    text-align: center;
    line-height: 56px;
    background-image: url(#{$img-path}about/bg_history-item-title.png);
    background-repeat: no-repeat;
    background-position: 50% 0;
    background-size: 100% auto;
  }
  > .charactors {
    margin: 20px 0 40px 0;
  }
  > .result-button {
    width: 540px;
    height: 100px;
    margin: 0 auto;
    @include tap-event();
  }
}
</style>
